var _path, _path2, _g, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10423_103308)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300 600C465.685 600 600 465.685 600 300C600 134.315 465.685 0 300 0C134.315 0 0 134.315 0 300C0 465.685 134.315 600 300 600Z",
    fill: "url(#paint0_radial_10423_103308)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10423_103308",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 600,
    height: 600
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M300 600C465.685 600 600 465.685 600 300C600 134.315 465.685 0 300 0C134.315 0 0 134.315 0 300C0 465.685 134.315 600 300 600Z",
    fill: "url(#paint1_radial_10423_103308)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10423_103308)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M-10 165C-10 158.373 -4.62742 153 2 153H166C172.627 153 178 158.373 178 165V444C178 450.627 172.627 456 166 456H2C-4.62742 456 -10 450.627 -10 444V165Z",
    fill: "url(#paint2_linear_10423_103308)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M362 407C362 400.373 367.373 395 374 395H588C594.627 395 600 400.373 600 407V511C600 517.627 594.627 523 588 523H374C367.373 523 362 517.627 362 511V407Z",
    fill: "#E74310"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M501 439C507.627 439 513 444.373 513 451L513 653C513 659.627 507.627 665 501 665H422C415.373 665 410 659.627 410 653L410 451C410 444.373 415.373 439 422 439L501 439Z",
    fill: "#DF3600"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M243 195C249.627 195 255 200.373 255 207L255 368C255 374.627 249.627 380 243 380H154C147.373 380 142 374.627 142 368L142 207C142 200.373 147.373 195 154 195L243 195Z",
    fill: "url(#paint3_linear_10423_103308)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M57 243C57 236.373 62.3726 231 69 231H215C221.627 231 227 236.373 227 243V396C227 402.627 221.627 408 215 408H69C62.3726 408 57 402.627 57 396V243Z",
    fill: "url(#paint4_linear_10423_103308)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M600 82C606.627 82 612 87.3726 612 94L612 296C612 302.627 606.627 308 600 308L414 308C407.373 308 402 302.627 402 296L402 94C402 87.3726 407.373 82 414 82L600 82Z",
    fill: "#FF9776"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M487 -52C493.627 -52 499 -46.6274 499 -40L499 182C499 188.627 493.627 194 487 194H383C376.373 194 371 188.627 371 182L371 -40C371 -46.6274 376.373 -52 383 -52L487 -52Z",
    fill: "#FFCA8C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M541 -12C547.627 -12 553 -6.62741 553 1.04904e-05L553 247C553 253.627 547.627 259 541 259H315C308.373 259 303 253.627 303 247L303 6.67572e-06C303 -6.62741 308.373 -12 315 -12L541 -12Z",
    fill: "url(#paint5_linear_10423_103308)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M212 -82C218.627 -82 224 -76.6274 224 -70L224 96C224 102.627 218.627 108 212 108H133C126.373 108 121 102.627 121 96L121 -70C121 -76.6274 126.373 -82 133 -82L212 -82Z",
    fill: "#DF3600"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M221 433C227.627 433 233 438.373 233 445V588C233 594.627 227.627 600 221 600L20 600C13.3726 600 8 594.627 8 588L8.00001 445C8.00001 438.373 13.3726 433 20 433L221 433Z",
    fill: "#DF3600"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M398 353C404.627 353 410 358.373 410 365L410 588C410 594.627 404.627 600 398 600L168 600C161.373 600 156 594.627 156 588L156 365C156 358.373 161.373 353 168 353L398 353Z",
    fill: "#FFD494"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M322 1.04907e-05C328.627 1.07804e-05 334 5.37259 334 12V70C334 76.6274 328.627 82 322 82L82 82C75.3726 82 70 76.6274 70 70L70 12C70 5.37258 75.3726 -2.89694e-07 82 0L322 1.04907e-05Z",
    fill: "#FFD494"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 582.157,
    y: 144.749,
    width: 635.56,
    height: 21.7974,
    transform: "rotate(135 582.157 144.749)",
    fill: "#DF3600"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 548.445,
    y: 112.036,
    width: 635.56,
    height: 28.3795,
    transform: "rotate(135 548.445 112.036)",
    fill: "#DF3600"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 529.476,
    y: 91.0674,
    width: 635.56,
    height: 28.3795,
    transform: "rotate(135 529.476 91.0674)",
    fill: "#F45C2C"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 511.476,
    y: 69.0674,
    width: 635.56,
    height: 23.357,
    transform: "rotate(135 511.476 69.0674)",
    fill: "#F45C2C"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 494.925,
    y: 52.5156,
    width: 635.56,
    height: 23.357,
    transform: "rotate(135 494.925 52.5156)",
    fill: "#FFBC6E"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 483.925,
    y: 30.5156,
    width: 635.56,
    height: 23.357,
    transform: "rotate(135 483.925 30.5156)",
    fill: "#DF3600"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.09,
    x: 335.879,
    y: -6.43848,
    width: 501.145,
    height: 23.357,
    transform: "rotate(135 335.879 -6.43848)",
    fill: "#FFD5A4"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.08,
    x: 316.879,
    y: -26.4844,
    width: 501.145,
    height: 23.357,
    transform: "rotate(135 316.879 -26.4844)",
    fill: "#FFD5A4"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    x: 299.879,
    y: -49.4844,
    width: 501.145,
    height: 23.357,
    transform: "rotate(135 299.879 -49.4844)",
    fill: "#FFD5A4"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 421.087,
    y: -15.4844,
    width: 582.05,
    height: 23.357,
    transform: "rotate(135 421.087 -15.4844)",
    fill: "#FFD5A4"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 432.087,
    y: 10.5156,
    width: 582.05,
    height: 23.357,
    transform: "rotate(135 432.087 10.5156)",
    fill: "#FFD5A4"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 367.799,
    y: 0.641602,
    width: 516.588,
    height: 23.357,
    transform: "rotate(135 367.799 0.641602)",
    fill: "#FFD5A4"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 581.494,
    y: 145.085,
    width: 635.56,
    height: 46.5984,
    transform: "rotate(135 581.494 145.085)",
    fill: "#DF3600"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 581.494,
    y: 145.085,
    width: 635.56,
    height: 46.8358,
    transform: "rotate(135 581.494 145.085)",
    fill: "#DF3600"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M299.556 364.731L185.417 297.211L299.556 107.867L413.593 297.211L299.556 364.731Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M299.556 479.69L185.417 318.932L299.556 386.35L413.696 318.932L299.556 479.69Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_10423_103308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(196 143.5) rotate(54.1675) scale(497.082)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED5A37"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_10423_103308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(196 143.5) rotate(54.1675) scale(497.082)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD794"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED5A37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10423_103308",
    x1: 84,
    y1: 153,
    x2: 84,
    y2: 456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE090",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10423_103308",
    x1: 198,
    y1: 195,
    x2: 198,
    y2: 366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF3600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF3600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10423_103308",
    x1: 57,
    y1: 320.283,
    x2: 214.135,
    y2: 320.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF3600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF3600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10423_103308",
    x1: 428,
    y1: -12,
    x2: 428,
    y2: 259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF3600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF3600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10423_103308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReth);
export default __webpack_public_path__ + "static/media/reth.00383e6842789c2388329d4405329e79.svg";
export { ForwardRef as ReactComponent };